import { render, staticRenderFns } from "./exchangeManagement.vue?vue&type=template&id=7d27ae90&"
import script from "./exchangeManagement.vue?vue&type=script&lang=js&"
export * from "./exchangeManagement.vue?vue&type=script&lang=js&"
import style0 from "./exchangeManagement.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports